// Centralized WhatsApp click tracker.
// Fires Google Ads conversions FIRST, then redirects only after the
// conversion beacons have been sent (using gtag's event_callback).
// A 1s safety timeout ensures users are never stuck if gtag is blocked.
//
// HYBRID TRACKING: fires BOTH conversion tags so we don't lose attribution.
// - NEW tag (created 31 May 2026) — primary, validates fast
// - OLD tag (legacy 2-year-old action) — kept for historical Smart Bidding signal

// Send to BOTH conversion actions via the official gtag "send_to" array.
const CONVERSION_SEND_TO = [
  'AW-16474493641/tk84CM7Ew7YcEMml0689', // NEW: Contact / WhatsApp Clicks 31st May
  'AW-16474493641/o1-ICOXUvcYaEMml0689', // OLD: WhatsApp Us - Nail (kept for history)
];
const PHONE_NUMBER = '918317599282';
const DEFAULT_MESSAGE = 'Hi! I would like to book an appointment at O2 Nails Hyd.';
const SAFETY_TIMEOUT_MS = 1000;

export const trackWhatsAppClick = ({ openInNewTab = false, message, location = 'unknown' } = {}) => {
  const waUrl = `https://wa.me/${PHONE_NUMBER}?text=${encodeURIComponent(message || DEFAULT_MESSAGE)}`;

  // Persist click to admin DB (fire-and-forget, never blocks redirect)
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type: 'whatsapp_click', location }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* ignore */ }

  const redirect = () => {
    if (openInNewTab) {
      window.open(waUrl, '_blank', 'noopener');
    } else {
      window.location.href = waUrl;
    }
  };

  // If gtag isn't loaded (ad blocker, slow network), redirect immediately.
  if (!window.gtag) {
    redirect();
    return;
  }

  // Guard so the callback only fires once (callback OR timeout, not both).
  let hasRedirected = false;
  const safeRedirect = () => {
    if (hasRedirected) return;
    hasRedirected = true;
    redirect();
  };

  // Fire conversion to BOTH tags. event_callback runs after Google receives the beacons.
  window.gtag('event', 'conversion', {
    send_to: CONVERSION_SEND_TO,
    value: 25.0,
    currency: 'INR',
    event_callback: safeRedirect,
  });

  // Safety net: never let the user wait longer than 1 second.
  window.setTimeout(safeRedirect, SAFETY_TIMEOUT_MS);
};
